import Controller from "@ember/controller"
import { action, get, set } from "@ember/object"
import { alias } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import type { Planbook } from "@shared/models/planbook"
import hasMany from "cc-frontend/helpers/has-many"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"

export default class StandardsTrackerController extends Controller {
  // Args
  planbook!: Planbook

  queryParams = ["courseIds", "standardSetId", "showStandardsNotCovered"]
  showStandardsNotCovered = false
  courseIds = []
  standardSetId = null
  canShowTrackerMenu = false

  // Services
  @service("ember-store") store!: EmberStore
  @service session!: Session
  @service rpc!: Rpc
  @service router
  @service modalManager!: ModalManager
  // @ts-ignore
  @service("queryParams") queryParamsService

  // CPs & Getters
  @alias("queryParamsService.current.hideNav") hideNav
  @hasMany("model.planbook", "course", "courses") courses

  // Actions
  @action
  toggleTrackerMenu() {
    set(this, "canShowTrackerMenu", !get(this, "canShowTrackerMenu"))
  }

  @action
  printOrDownload() {
    this.modalManager.openModal("planner/modals/print-download", {
      planbookId: (this.model as any).planbook.id,
      courseIds: this.courseIds,
      standardSetId: this.standardSetId,
      showStandardsNotCovered: this.showStandardsNotCovered,
      layout: "planbook-standards",
      canPrint: true,
      dateRangeString: "Standards Tracker",
      currentUserId: this.session.userId,
    })
  }

  //TODO modal for paywall and redirect
}
